/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="108"
    viewBox="0 0 108 108"
    width="108"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <filter
      id="a"
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
      height="108"
      width="108"
      x="0"
      y="0"
    >
      <feFlood floodOpacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset dy="2" />
      <feGaussianBlur stdDeviation="5" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
      <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
      <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
    </filter>
    <g filter="url(#a)">
      <rect height="88" rx="16" width="88" x="10" y="8" />
      <rect height="88" rx="10" width="88" x="10" y="8" />
      <g strokeWidth="2">
        <ellipse cx="27.5" cy="31" rx="2.5" ry="2" />
        <ellipse cx="86" cy="34.5" rx="2" ry="2.5" />
        <circle cx="82" cy="60" r="2" />
        <ellipse cx="76.5" cy="46" rx="2.5" ry="2" />
        <ellipse cx="54" cy="52.5" rx="2" ry="2.5" transform="matrix(-1 0 0 -1 108 105)" />
        <ellipse cx="22" cy="53.5" rx="2" ry="2.5" />
        <ellipse cx="27.5" cy="46" rx="2.5" ry="2" />
        <ellipse cx="86" cy="52.5" rx="2" ry="2.5" />
        <circle cx="82" cy="75" r="2" />
        <path d="m27 33v11" strokeLinecap="round" />
        <path d="m86 37v12" strokeLinecap="round" />
        <path d="m82 62v11" strokeLinecap="round" />
        <path d="m22 57v10" strokeLinecap="round" />
        <circle cx="32" cy="59" r="2" />
        <ellipse cx="22" cy="70.5" rx="2" ry="2.5" />
        <g strokeLinecap="round">
          <path d="m31 46h3" />
          <path d="m74 60h6" />
          <path d="m32 62v5" />
          <path d="m76 39v5" />
          <path d="m54 57v-2" />
          <path d="m24 54h10" />
          <path d="m74 53h10" />
        </g>
        <rect height="28" rx="2" width="32" x="38" y="42" />
        <path d="m38 63c0 1.1046.8954 2 2 2h28c1.1046 0 2-.8954 2-2" />
        <path d="m46 42v-7.5c0-4.1421 3.8056-7.5 8.5-7.5s8.5 3.3579 8.5 7.5v7.5" />
        <path d="m50 41v-5c0-2.7614 1.7909-5 4-5s4 2.2386 4 5v5" />
      </g>
    </g>
  </svg>
);
